import { render, staticRenderFns } from "./DealHealthBar.vue?vue&type=template&id=167a6193&scoped=true"
import script from "./DealHealthBar.vue?vue&type=script&lang=js"
export * from "./DealHealthBar.vue?vue&type=script&lang=js"
import style0 from "./DealHealthBar.vue?vue&type=style&index=0&id=167a6193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a6193",
  null
  
)

export default component.exports